<template lang="pug">
    #estimate-preview
        v-banner.no-print.title-banner(min-height="88")
            div.d-flex.align-center
                .text-h4.font-weight-bold {{$t('Menu.__Sales')}} : {{$t('EstimatesAndInvoices.__View') + " " + estimate.name + " #" + estimate.number}}
                //- v-chip.ml-4(small color="success") 已儲存
                v-chip.ml-4(dark small :color="getStatusColor(estimate.status)") {{$t('Status.__' + estimate.status)}}
            template(v-slot:actions)
                v-menu(open-on-hover offset-y)
                    template(v-slot:activator="{ on }")
                        v-btn(rounded v-on="on" color="primary")  
                            | {{$t('EstimatesAndInvoices.__SendEstimate')}}
                            v-icon(right dark) keyboard_arrow_down
                    v-list
                        template(v-for="item in sendActionItems")
                            v-list-item(@click="item.click()")
                                v-list-item-title {{item.title}}
                            v-divider(v-if="item.devider")

        v-container
            ConfirmDialog(v-model="deleteDialog" :title="$t('EstimatesAndInvoices.__DeleteEstimate')" :message="$t('EstimatesAndInvoices.__ConfirmDeleteEstimate')" :cancel-text="$t('ActionOption.__Cancel')" :confirm-text="$t('ActionOption.__Delete')" :confirm-action="deleteEstimate")
            
            //- v-row.no-print.py-0
            .d-md-flex.no-print.py-0
                //- v-col.py-0.text-left
                v-btn.my-2.ma-2(rounded dark color="#b4b9be" @click="customerView()") 
                    v-icon.mr-2(small) visibility
                    | {{$t('EstimatesAndInvoices.__PreviewAsCustomer')}}
                v-spacer.d-none.d-md-block
                v-btn.my-2.ma-2(rounded dark color="#b4b9be" @click="edit") {{$t('EstimatesAndInvoices.__Edit')}}
                v-btn.my-2.ma-2(rounded dark color="#b4b9be" @click="convert") {{$t('EstimatesAndInvoices.__ConvertToInvoice')}}
                v-menu(open-on-hover offset-y)
                    template(v-slot:activator="{ on }")
                        v-btn.my-2.ma-2(rounded dark v-on="on" color="#b4b9be") 
                            | {{$t('ActionOption.__More')}}
                            v-icon(right dark) keyboard_arrow_down
                    v-list
                        template(v-for="item in moreActionItems")
                            v-list-item(@click="item.click()")
                                v-list-item-title {{item.title}}
                            v-divider(v-if="item.devider")
            v-row
                v-col(cols="12")
                    .pdf-container.pa-md-0.pa-3
                        Alert(permanent)
                        #pdf.pdf-view
                            EstimateViewPage(:data="estimate")

            SharedLinkDialog(v-model="sharedDialog" :link="sharedLink" :title="$t('EstimatesAndInvoices.__ShareEstimate')" :message="$t('EstimatesAndInvoices.__ShareHint')" :confirmText="$t('EstimatesAndInvoices.__CopyLink')" )
            SendingEmailDialog(v-model="sendEmailDialog" :title="$t('EstimatesAndInvoices.__SendEstimate')" radioSubtitleKey="EstimatesAndInvoices.__UseCustomerInfo" :customer="estimate.customer" category="estimate" :id="id")
            ConfirmDialog(v-model="convertDialog" :title="$t('EstimatesAndInvoices.__ConvertToInvoice')" :message="$t('EstimatesAndInvoices.__ConvertHint')" :cancel-text="$t('ActionOption.__Cancel')" :confirm-text="$t('ActionOption.__Convert')" :confirm-action="convertEstimate2Invoice")


</template>
<script>
import EstimateViewPage from "@/components/EstimateViewPage"
import SharedLinkDialog from "@/components/dialogs/SharedLinkDialog"
import SendingEmailDialog from "@/components/dialogs/SendingEmailDialog"

import * as PDF from "@/utils/pdf"

export default {
  components: {
    EstimateViewPage,
    SharedLinkDialog,
    SendingEmailDialog
  },
  data() {
    return {
      id: "",
      title: "",
      deleteDialog: false,
      convertDialog: false,
      sharedDialog: false,
      sharedLink: "",
      sendEmailDialog: false,
      sendActionItems: [
        {
          title: this.$t("EstimatesAndInvoices.__SendVia2SUMUP"),
          click: this.sendEmail
        },
        {
          title: this.$t("EstimatesAndInvoices.__GetLink"),
          click: this.shareLink
        }
      ],
      moreActionItems: [
        {
          title: this.$t("ActionOption.__Duplicate"),
          click: this.duplicateEstimate
        },
        {
          title: this.$t("ActionOption.__ExportPDF"),
          click: this.downloadPDF
        },
        {
          title: this.$t("ActionOption.__Print"),
          devider: true,
          click: this.print
        },
        { title: this.$t("ActionOption.__Delete"), click: this.delete }
      ],
      statusItems: [
        // {
        //     text: this.$t("Status.__Draft"),
        //     color: "#dcdcdc",
        //     key: "Draft"
        // },
        {
          text: this.$t("Status.__Unsent"),
          color: "#505356",
          key: "Unsent"
        },
        {
          text: this.$t("Status.__Sent"),
          color: "#14c8c8",
          key: "Sent"
        },
        {
          text: this.$t("Status.__Viewed"),
          color: "primary",
          key: "Viewed"
        },
        {
          text: this.$t("Status.__Expired"),
          color: "#e6465a",
          key: "Expired"
        }
      ],
      estimate: {}
    }
  },
  methods: {
    getStatusColor(status) {
      for (var item of this.statusItems) {
        if (item.key == status) {
          return item.color
        }
      }
    },
    customerView() {
      this.$router.push({
        name: "EstimateCustomerView",
        params: {
          id: this.id
        }
      })
    },
    print() {
      this.$router.push({
        name: "EstimateExport",
        params: {
          estimateId: this.id,
          exportType: "print"
        }
      })
    },
    edit() {
      this.$router.push({
        name: "EstimateEdit",
        params: {
          id: this.id
        }
      })
    },
    sendEmail() {
      this.sendEmailDialog = true
    },
    shareLink() {
      this.$store
        .dispatch("estimates/shareEstimate", this.id)
        .then(
          function(response) {
            var token = response.data.token
            this.sharedLink = process.env.VUE_APP_DOMAIN + "share/estimates/" + token

            this.sharedDialog = true

            this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
        .catch(function(error) {}.bind(this))
    },
    convert() {
      this.convertDialog = true
    },
    convertEstimate2Invoice() {
      this.$store
        .dispatch("estimates/convertEstimate2Invoice", this.id)
        .then(
          function(response) {
            this.$store.dispatch("global/stopLoading")
            this.$store.dispatch("global/showAlertSuccess", this.$t("Messages.__SuccessfullyConverted"))
          }.bind(this)
        )
        .catch(
          function(error) {
            this.$store.dispatch("global/showAlertError", error.message)
          }.bind(this)
        )
      this.convertDialog = false
    },
    duplicateEstimate() {
      this.$store
        .dispatch("estimates/duplicateEstimate", this.id)
        .then(
          function(response) {
            this.$store.dispatch("global/stopLoading")
            this.$store.dispatch("global/showAlertSuccess", this.$t("Messages.__SuccessfullyDuplicated"))
          }.bind(this)
        )
        .catch(
          function(error) {
            this.$store.dispatch("global/stopLoading")
            this.$store.dispatch("global/showAlertError", error.message)
          }.bind(this)
        )
    },
    getEstimate(id) {
      this.$store.dispatch("global/startLoading")
      this.$store
        .dispatch("estimates/getEstimate", id)
        .then(
          function(response) {
            this.estimate = response.data

            this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
        .catch(
          function(error) {
            this.$store.dispatch("global/showAlertError", error.message)
            this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
    },
    delete() {
      this.deleteDialog = true
    },
    deleteEstimate() {
      this.$store.dispatch("global/startLoading")
      this.$store
        .dispatch("estimates/deleteEstimate", this.id)
        .then(
          function(response) {
            this.$store.dispatch("global/stopLoading")
            this.$router.push({
              name: "Estimates",
              params: {
                alert: {
                  message: this.$t("Messages.__SuccessfullyDeleted"),
                  type: "success"
                }
              }
            })
          }.bind(this)
        )
        .catch(
          function(error) {
            this.$store.dispatch("global/stopLoading")
            this.$store.dispatch("global/showAlertError", error.message)
          }.bind(this)
        )
      this.deleteDialog = false
    },
    downloadPDF() {
      PDF.download("#estimate-preview-page", this.estimate.name + "_" + this.estimate.number, () => {})
    }
  },
  created() {
    this.id = this.$route.params.id
    this.getEstimate(this.id)
  }
}
</script>
<style lang="scss" scoped>
.pdf-view {
  max-width: 1024px;
  min-height: 1248px;
}
</style>
